const defaultRuntimeData = {
  key: 'value',
};

export default defaultRuntimeData;
